import React, { FC } from 'react'
import s from './ReviewPagination.module.sass'
import { loadMoreReviews } from '@entities/Restaurant/Reviews/model/thunks'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { Pagination } from '@features/Common/Pagination'

interface Props {
  className: string
  onClick?: () => void
  loading?: boolean
}

const ReviewPagination: FC<Props> = ({ className = '', onClick, loading }) => {
  const dispatch = useAppDispatch()
  const stateReviews = useAppSelector((state) => state.entities.restaurant_reviews)
  const { pagination } = stateReviews

  const handleClickInner = () => {
    if (onClick) onClick()
    else dispatch(loadMoreReviews())
  }

  return (
    <ErrorBoundary>
      {pagination?.page?.next.number && (
        <Pagination
          mode={'load-more'}
          loading={loading}
          currentPage={pagination?.page.current.number}
          pageCount={pagination?.page.count}
          handleLoadMore={handleClickInner}
          analytic={{ section_name: 'reviews' }}
          className={`${s.pagination} ${className}`}
        />
      )}
    </ErrorBoundary>
  )
}

export default ReviewPagination
